import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  input,
  OnInit,
  Output,
  signal,
} from '@angular/core';
import { AuthService, InstallersService } from '@ubie/core';

@Component({
  selector: 'acl-installation-type',
  standalone: false,
  templateUrl: './installation-type.component.html',
  styleUrl: './installation-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallationTypeComponent implements OnInit {
  private readonly installerService = inject(InstallersService);
  private readonly authService = inject(AuthService);

  // Emit an event when a product was chosen
  @Output() readonly typeSelected = new EventEmitter<void>();
  // Text to display on button
  readonly btnText = input<string>('');

  readonly installerCode = signal('');
  readonly isNewSelected = signal(true);
  readonly isExistingSelected = signal(false);

  ngOnInit(): void {
    this.getInstallerCode();
  }

  /**
   * Get the installer code from the database
   */
  getInstallerCode(): void {
    this.installerService
      .getInstallerCode(this.authService.getUserId() ?? 0)
      .subscribe({
        next: (data) => {
          this.installerCode.set(data);
        },
        error: () => {
          this.installerCode.set('unknown code');
        },
      });
  }

  /**
   * Existing installation was selected
   */
  onExistingSelected(): void {
    this.isExistingSelected.set(true);
    this.isNewSelected.set(false);
  }

  /**
   * New installation was selected
   */
  onNewSelected(): void {
    this.isNewSelected.set(true);
    this.isExistingSelected.set(false);
  }

  /**
   * Next button was clicked
   */
  submitType(): void {
    if (this.isNewSelected()) {
      this.typeSelected.emit();
    }
  }
}
